/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

// Components
import Badge from 'shared/ui/components/Badge.vue';

const __vue_script__ = {
    name: 'Mailing',

    components: {
        Badge
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: true,
            mailingDoc: {}
        };
    },

    computed: {
        count() {
            return this.mailingDoc.fpExtIds?.length || 0;
        },

        isInProgress() {
            if (isEmpty(this.mailingDoc)) {
                return true;
            }
            const isCompleted = this.mailingDoc.status === 'completed';
            const isScheduled = this.mailingDoc.status === 'scheduled';
            const isCancel = this.mailingDoc.status === 'cancelled';
            const isFailed = this.mailingDoc.status === 'failed';
            const areAllProcessed = this.mailingDoc.fpExtIds?.length <= this.mailingDoc.processedFpExtIds?.length;

            return !isScheduled && !isCancel && !isFailed && (!isCompleted || !areAllProcessed);
        },

        scheduled() {
            return (this.mailingDoc.scheduled_at || this.mailingDoc.fp_created_at);
        },

        statusClass() {
            return this.mailingDoc.status !== 'failed' ? 'badge-success' : 'badge-danger';
        },

        progress() {
            const total = this.mailingDoc.fpExtIds?.length || 0;
            const processed = this.mailingDoc.processedFpExtIds?.length || 0;

            if (!total || ['scheduled', 'cancelled'].includes(this.mailingDoc.status)) {
                return '';
            }

            return (processed * 100 / total).toFixed(2) + '%';
        },

        processed() {
            return (this.mailingDoc.processedFpExtIds || []).length;
        },

        unsubscribed() {
            return (this.mailingDoc.skippedUnsubscribedFpExtIds || []).length;
        },

        noDoc() {
            return (this.mailingDoc.notFoundFpExtIds || []).length;
        },

        noAddress() {
            return (this.mailingDoc.missingEmailFpExtIds || []).length;
        }
    },

    async created() {
        await this.loadDocument();
        this.progressLoop();
    },

    methods: {
        async loadDocument() {
            try {
                if (this.loading) {
                    return;
                }

                this.loading = true;
                const eid = this.params.event._id;
                const mailingId = this.$router.getRouteParams().modelId;
                const mailingDoc = await this.$services.documents.getDocById(eid, mailingId);
                this.mailingDoc = mailingDoc;
            } catch (error) {
                console.error('[Mailing] Could not load mailing document', error.message);
            } finally {
                this.loading = false;
            }
        },

        async progressLoop() {
            if (this.isInProgress) {
                await this.loadDocument();
                setTimeout(this.progressLoop, 1000);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"mailing"},[_c('h1',[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.title')))])]),_c('div',{staticClass:"mailing-summary"},[_c('div',{staticClass:"table-wrapper"},[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.headers.template')))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.headers.scheduled_at')))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.headers.status')))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.headers.progress'))),(_vm.isInProgress)?_c('i',{staticClass:"icon-spinner icon-spin"}):_vm._e()])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.mailingDoc.name))]),_c('td',[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(_vm.scheduled, 'LLL', _vm.params.event.timezone)))]),_c('td',[_c('badge',{class:_vm.statusClass},[_vm._v(_vm._s(_vm.mailingDoc.status))])],1),_c('td',[_vm._v(_vm._s(_vm.progress))])])])])])]),(_vm.mailingDoc.status !== 'scheduled')?_c('div',{staticClass:"mailing-details"},[_c('div',{staticClass:"table-wrapper"},[_c('table',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.processed')))]),_c('td',[_vm._v(_vm._s(_vm.processed))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.no_doc')))]),_c('td',[_vm._v(_vm._s(_vm.noDoc))])]),_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.unsubscribed')))]),_c('td',[_vm._v(_vm._s(_vm.unsubscribed))]),_c('th',[_vm._v(_vm._s(_vm.$t('emailing.mailing.details.no_address')))]),_c('td',[_vm._v(_vm._s(_vm.noAddress))])])])])]):_vm._e()]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Mailing.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__